module.exports = __webpack_public_path__ + "static/media/deleteicon.e3497f38.svg";